import Image from 'next/image';
import * as React from 'react';

import { type OrgColorTheme } from '../types';

const SidebarLogo = ({ theme, mode }: { theme: OrgColorTheme; mode: keyof OrgColorTheme['logo'] }) => (
	<div id='pca__sidebar-logo'>
		<Image
			id='pca__logo-image'
			alt='App Logo'
			src={theme.logo[mode].src}
			height={theme.logo[mode].height}
			width={theme.logo[mode].width}
			data-cy='sidebar-logo'
		/>
	</div>
);

export const SmallSidebarLogo = (props: { theme: OrgColorTheme }) => <SidebarLogo {...props} mode='small' />;
export const LargeSidebarLogo = (props: { theme: OrgColorTheme }) => <SidebarLogo {...props} mode='large' />;
